module.exports = __webpack_public_path__ + "2808ad911de45b3913695a2f5c491cd5.svg";